import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PrintManagerService {
  // Local Electron REST API URL
  private readonly localAgentUrl = 'http://localhost:4500/api';
  private readonly apiKey = 'meena-secret-hardware-api-key-2026';
  private readonly apiKeyHeaderName = 'x-meena-api-key';

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) {}

  // --- LARAVEL BACKEND ENDPOINTS (PRINTER CONFIGURATION MASTER) ---

  getSavedPrinters(firmId: number): Observable<any> {
    return this.apiService.get(`printers?firm_id=${firmId}`);
  }

  savePrinter(printerData: any): Observable<any> {
    return this.apiService.post('printers', printerData);
  }

  updatePrinter(id: number, printerData: any): Observable<any> {
    return this.apiService.update(`printers/${id}`, printerData);
  }

  setDefaultPrinter(id: number): Observable<any> {
    return this.apiService.update(`printers/${id}/default`, {});
  }

  deletePrinter(id: number): Observable<any> {
    return this.apiService.delete(`printers/${id}`);
  }

  // --- ELECTRON LOCAL AGENT ENDPOINTS ---

  private getLocalHeaders(): HttpHeaders {
    return new HttpHeaders({
      [this.apiKeyHeaderName]: this.apiKey,
      'Content-Type': 'application/json'
    });
  }

  /**
   * Fetch hardware-level status from the local agent
   */
  getLocalAgentStatus(): Observable<any> {
    // This is public, no auth header needed
    return this.http.get(`${this.localAgentUrl}/gateway/status`);
  }

  /**
   * Discover printers physically connected/installed on the OS
   */
  discoverLocalPrinters(): Observable<any> {
    return this.http.get(`${this.localAgentUrl}/printers/discover`, {
      headers: this.getLocalHeaders()
    });
  }

  /**
   * Dispatch raw Label JSON model to the Electron agent's print queue
   */
  printLabels(labelModel: any): Observable<any> {
    return this.http.post(`${this.localAgentUrl}/printers/print`, labelModel, {
      headers: this.getLocalHeaders()
    });
  }

  /**
   * Query local spool queue jobs status
   */
  getLocalJobs(): Observable<any> {
    return this.http.get(`${this.localAgentUrl}/printers/jobs`, {
      headers: this.getLocalHeaders()
    });
  }

  /**
   * Request local agent to clear its print queue
   */
  clearLocalJobs(): Observable<any> {
    return this.http.delete(`${this.localAgentUrl}/printers/jobs`, {
      headers: this.getLocalHeaders()
    });
  }
}
